<main class="page-wrapper">
  <app-header id="top"></app-header>

  <section class="container my-5 pt-5 pb-lg-5">
    <article class="legal-document">
      <app-breadcrumbs [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
      <h1 class="legal-document__page-title text-light mb-4">{{ tituloKey | transloco }}</h1>

      @if (carregando) {
        <p class="text-light opacity-70">{{ 'common.loading' | transloco }}</p>
      } @else if (erro) {
        <p class="text-danger">{{ erro | transloco }}</p>
      } @else {
        <div class="legal-document__body text-light" [innerHTML]="conteudoHtml"></div>
      }
    </article>
  </section>
</main>

<app-footer></app-footer>
